import { render, staticRenderFns } from "./ContentProducers.vue?vue&type=template&id=3cd9126a&scoped=true"
import script from "./ContentProducers.vue?vue&type=script&lang=js"
export * from "./ContentProducers.vue?vue&type=script&lang=js"
import style0 from "./ContentProducers.vue?vue&type=style&index=0&id=3cd9126a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd9126a",
  null
  
)

export default component.exports